import { GetPlayerGroups } from "@grassrootly/api";
import useBaseRequest from "../../api/BaseRequest";
import { useCallback } from "react";
import { store, useAppDispatch } from "@grassrootly/rn-core";
import { useFocusEffect } from "@react-navigation/native";
import { groupsActions } from "../../api/groups/GroupsReducer";

export function useMyGroups() {
  const dispatch = useAppDispatch();

  const { execute, data, loading } = useBaseRequest(GetPlayerGroups, {
    onCompleted: (data) => {
      if (!data || !data.length) return;
      dispatch(groupsActions.setPlayerGroups(data));
    },
  });

  useFocusEffect(useCallback(() => {
    const playerId = store.getState().auth?.user?.id || 0;
    execute({ playerId });
  }, []));

  return { groups: data, loading };
}
